module.exports = __webpack_public_path__ + "img/rec-17.4bd06b77.jpg";